import React from "react";
import { useAppState } from "src/state";
import { ObjectCardItem } from "src/components/ui/ObjectCard";
import { Box, Divider, Group, Paper, SimpleGrid, Stack } from "@mantine/core";
import { typedEntries } from "src/state/_types";

import { OperationsAdminVenueBookingViewSchema } from "src/components/operations/administrator/bookings/OperationsAdminVenueBookingViewSchema";

import { Icon } from "@iconify/react/dist/iconify.js";
import { Icons } from "src/components/ui/Icons";
import { BookingStatusTag } from "src/screens/agency/operations/administrator/bookings/AgencyOperationsAdminBookings";

export function OperationsAdminVenueBookingView() {

    const { currentItem } = useAppState().bookings;

    if (!currentItem) return null;

    return (
        <Stack >

            <Paper bg="white" p="md" shadow="xs">

                <Divider
                    my="0"
                    variant="dashed"
                    labelPosition="left"
                    color="var(--mantine-color-gray-4)"
                    styles={{
                        label: {
                            color: 'var(--mantine-color-gray-7)',
                            fontWeight: 400,
                            fontSize: '16px',
                        }
                    }}
                    label={
                        <Group gap="3" align="center" justify="flex-start">
                            <Icon icon={Icons.booking} width={20} />
                            <Box ml={5}>Booking Overview</Box>
                        </Group>
                    }
                />

                <Box p="8px">

                    <SimpleGrid cols={4} spacing="xs">

                        {OperationsAdminVenueBookingViewSchema.enums.map((item) => {
                            const value = "relation_field" in item
                                ? currentItem[item.field] as any // typed by union
                                : currentItem[item.field];
                            return (
                                <ObjectCardItem key={item.field} label={item.label} value={value} type={item.type} element={<BookingStatusTag status={value!} />} />
                            )
                        })}

                        {OperationsAdminVenueBookingViewSchema.fields.map(({ label, field, type }) => {
                            return (
                                <ObjectCardItem key={field} label={label} value={currentItem[field]} type={type} />
                            )
                        })}

                    </SimpleGrid>

                </Box>

            </Paper>

            {OperationsAdminVenueBookingViewSchema.relations
                ? typedEntries(OperationsAdminVenueBookingViewSchema.relations).map(([relKey, relSchema]) => {
                    const rel = currentItem[relKey];                // T[K]
                    if (!rel) return null;
                    const entity = rel as NonNullable<typeof rel>; // strip Maybe/undefined

                    if (!relSchema) return null;

                    const rows = relSchema.fields.map(({ label, field, type }) => ({
                        label,
                        type,
                        value: entity[field],   // field is keyof NonNullable<T[K]> ✅
                    }));

                    return (
                        <React.Fragment key={String(relKey)}>
                            <Paper bg="white" p="md" shadow="xs">

                                <Divider
                                    my="0"
                                    variant="dashed"
                                    labelPosition="left"
                                    label={
                                        <Group gap="3" align="center" justify="flex-start">
                                            <Icon icon={(Icons as any)[relKey] || Icons.point} width={20} />
                                            <Box ml={5}>{relSchema.label}</Box>
                                        </Group>
                                    }
                                    color="var(--mantine-color-gray-4)"
                                    styles={{
                                        label: {
                                            color: 'var(--mantine-color-gray-7)',
                                            fontWeight: 400,
                                            fontSize: '16px',
                                        }
                                    }}
                                />

                                <Box key={String(relKey)} p="8px">

                                    <SimpleGrid cols={3} spacing="xs">
                                        {rows.map(({ label, value, type }) => (
                                            <ObjectCardItem key={label} label={label} value={value} type={type} />
                                        ))}
                                    </SimpleGrid>

                                </Box>

                            </Paper>
                        </React.Fragment>
                    );
                })
                : null}

        </Stack>
    );
}